import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/components/Main/Home'
import Login from './components/Login/index.vue'
import LoginLogin from './components/Login/Login.vue'
import LoginLoginEmail from './components/Login/LoginEmail.vue'
import LoginOrg from './components/Login/Org.vue'
import LoginRegister from './components/Login/Register.vue'
import Main from './components/Main/index.vue'
import Cf from './components/Main/Cf/index.vue'
import CfList from './components/Main/Cf/List.vue'
import CfProject from './components/Main/Cf/Project/index.vue'
import CfProjectFeedback from './components/Main/Cf/Project/Feedback.vue'
import CfProjectStat from './components/Main/Cf/Project/Stat.vue'
import CfFeedbackDetail from './components/Main/Cf/FeedbackDetail.vue'
import Contact from './components/Main/Contact/index.vue'
import ContactList from './components/Main/Contact/List.vue'
import ContactOrg from './components/Main/Contact/Org.vue'
import ContactTag from './components/Main/Contact/Tag.vue'
import ContactContact from './components/Main/Contact/Contact/index.vue'
import ContactContactInfo from './components/Main/Contact/Contact/Info.vue'
import ContactContactLog from './components/Main/Contact/Contact/Log.vue'
import ContactContactAttachment from './components/Main/Contact/Contact/Attachment.vue'
import ContactContactRemark from './components/Main/Contact/Contact/Remark.vue'
import Dashboard from './components/Main/Dashboard/index.vue'
import Form from './components/Main/Form/index.vue'
import FormList from './components/Main/Form/List.vue'
import FormFeedback from './components/Main/Form/Feedback.vue'
import FormFeedbackDetail from './components/Main/Form/FeedbackDetail.vue'
import Search from './components/Main/Search.vue'
import Share from './components/Main/Share.vue'

import Activity from './components/Main/Activity/index.vue'
import ActivityList from './components/Main/Activity/List.vue'
import ActivityDetail from './components/Main/Activity/Detail.vue'
import ActivityFeedback from './components/Main/Activity/Feedback.vue'
import ActivityFeedbackDetail from './components/Main/Activity/FeedbackDetail.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: HomePage,
  redirect: { name: 'dashboard' },
  children: [{
    path: 'auth',
    component: Login,
    children: [{
      path: '',
      component: LoginLogin
    }, {
      name: 'login',
      path: 'login',
      component: LoginLogin
    }, {
      name: 'login-email',
      path: 'login-email',
      component: LoginLoginEmail
    }, {
      name: 'login-org',
      path: 'org',
      component: LoginOrg
    }, {
      name: 'register',
      path: 'register',
      component: LoginRegister
    }, {
      name: 'register1',
      path: 'register1',
      component: LoginRegister
    }, {
      name: 'register2',
      path: 'register2',
      component: LoginRegister
    }]
  }, {
    path: 'main',
    component: Main,
    children: [{
      path: 'cf',
      component: Cf,
      children: [{
        name: 'cf',
        path: '',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: CfList
      }, {
        path: 'project',
        component: CfProject,
        children: [{
          path: '',
          meta: {
            nav: { share: true },
            bottomBar: { type: 'close-notification', highlight: true, key: 'cf_donate' }
          },
          component: CfProjectFeedback
        }, {
          path: 'feedback',
          meta: {
            nav: { share: true },
            bottomBar: { type: 'close-notification', highlight: true, key: 'cf_donate' }
          },
          component: CfProjectFeedback
        }, {
          path: 'stat',
          meta: {
            nav: { share: true },
            bottomBar: { type: 'close-notification', highlight: true, key: 'cf_donate' }
          },
          component: CfProjectStat
        }]
      }, {
        path: 'feedback-detail',
        meta: {
          nav: { share: true },
          bottomBar: { type: 'prev-next' }
        },
        component: CfFeedbackDetail
      }]
    }, {
      path: 'contact',
      component: Contact,
      children: [{
        name: 'contact',
        path: '',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: ContactList
      }, {
        path: 'list',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: ContactList
      }, {
        path: 'org',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: ContactOrg
      }, {
        path: 'tag',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: ContactTag
      }, {
        path: 'contact',
        component: ContactContact,
        children: [{
          path: '',
          meta: {
            nav: { share: false },
            bottomBar: { type: 'contact-bottom-bar' }
          },
          component: ContactContactInfo
        }, {
          path: 'info',
          meta: {
            nav: { share: false },
            bottomBar: { type: 'contact-bottom-bar' }
          },
          component: ContactContactInfo
        }, {
          path: 'log',
          meta: {
            nav: { share: false },
            bottomBar: { type: 'contact-bottom-bar' }
          },
          component: ContactContactLog
        }]
      }, {
        path: 'remark',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: ContactContactRemark
      }, {
        path: 'attachment',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: ContactContactAttachment
      }]
    }, {
      name: 'dashboard',
      path: 'dashboard',
      meta: {
        nav: false,
        menu: false,
        bottomBar: { type: 'bottom-tabs' }
      },
      component: Dashboard
    }, {
      path: 'form',
      component: Form,
      children: [{
        name: 'form',
        path: '',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: FormList
      }, {
        path: 'feedback',
        meta: {
          nav: { share: true },
          bottomBar: { type: 'close-notification', highlight: true, key: 'formfill' }
        },
        component: FormFeedback
      }, {
        path: 'feedback-detail',
        meta: {
          nav: { share: true },
          bottomBar: { type: 'prev-next' }
        },
        component: FormFeedbackDetail
      }]
    }, {
      name: 'share',
      path: 'share',
      meta: {
        nav: { share: false }
      },
      component: Share
    }, {
      name: 'search',
      path: 'search',
      meta: {
        nav: { share: false, searchOpen: true }
      },
      component: Search
    }, {
      path: 'activity',
      component: Activity,
      children: [{
        name: 'activity',
        path: '',
        meta: {
          nav: { share: false },
          bottomBar: { type: 'bottom-tabs' }
        },
        component: ActivityList
      }, {
        name: 'activityDetail',
        path: 'detail',
        props: (route) => ({
          activityId: route.query.activityId,
          openScanQRCode: Boolean(route.query.scan)
        }),
        meta: {
          nav: { share: true },
          keepAlive: true
        },
        component: ActivityDetail
      }, {
        name: 'activityFeedback',
        path: 'feedback',
        meta: {
          nav: { share: true },
          bottomBar: { type: 'close-notification', highlight: true, key: 'activity_signup' }
        },
        component: ActivityFeedback
      }, {
        path: 'feedback-detail',
        meta: {
          nav: { share: true },
          bottomBar: { type: 'prev-next' }
        },
        component: ActivityFeedbackDetail
      }]
    }]
  }]
}]

export const route = {
  authenticated: window.X.authenticated
}

export const router = new VueRouter({
  mode: 'hash',
  saveScrollPosition: false,
  routes
})

const redirectOfLogin = (path, next) => {
  const authenticated = route.authenticated
  if (path.indexOf('/auth') === 0) {
    if (authenticated) {
      next({ name: 'dashboard' })
    }
  } else if (path.indexOf('/main') === 0) {
    if (!authenticated) {
      next({ name: 'login' })
    }
  }
  next()
}

router.beforeEach((to, from, next) => {
  // 百度统计
  const pageURL = to.fullPath
  if (window._hmt) {
    window._hmt.push(['_trackPageview', pageURL])
  }
  redirectOfLogin(to.path, next)
})

router.afterEach(route => {
  // 未登录时直接访问 /main/dashboard 或 登录后直接访问 /auth/login 的情况
  redirectOfLogin(route.path, location => {
    if (location) {
      router.replace(location).catch(err => {
        throw new Error(err)
      })
    }
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router.js